import gql from "graphql-tag";

export const formSubmit = gql`
  mutation FormSubmit($form: ciclFormInput!) {
    ciclFormSubmit(form: $form) {
      id
    }
  }
`;
